import React from "react";
import Image from "next/image";
import { Container } from "./styles";
import { useRotateSliderValue } from "@/services/zustand/slider_rotate";

export const Gallery = () => {
  let [carouselItems, setCarouselItems] = React.useState<any[]>([]);
  const galleryContainer = React.useRef<any>(null);
  const galleryControlsContainer = React.useRef<any>(null);
  const selectedItem = useRotateSliderValue((props) => props.selectedItem);

  React.useEffect(() => {
    if (galleryContainer.current) {
      const items = document.querySelectorAll(
        ".gallery-item"
      ) as unknown as any[];
      setCarouselItems(Array.from(items));
    }
  }, [galleryContainer]);

  React.useEffect(() => {
    // useControls();
  }, []);

  const updateGallery = React.useCallback(() => {
    carouselItems.forEach((el: any) => {
      el?.classList.remove(
        "gallery-item-1",
        "gallery-item-2",
        "gallery-item-3",
        "gallery-item-4",
        "gallery-item-5"
      );
    });

    [...carouselItems].slice(0, 5).forEach((el: any, i) => {
      el?.classList.add(`gallery-item-${i + 1}`);
    });
  }, [carouselItems]);

  const setCurrentState = React.useCallback(
    (direction: any) => {
      const nextItems =
        carouselItems.length > 0
          ? [...carouselItems]
          : Array.from(galleryContainer.current.childNodes);

      if (direction === "previous") {
        const lastItem = nextItems.pop();
        nextItems.unshift(lastItem);
      } else {
        const firstItem = nextItems.shift();
        nextItems.push(firstItem);
      }

      nextItems?.forEach((item, index) => {
        item.className = `gallery-item gallery-item-${index + 1}`;
      });

      nextItems?.forEach((item) => {
        if (item.className === "gallery-item gallery-item-3") {
          useRotateSliderValue.setState({
            selectedItem: item.dataset.item,
          });
        }
      });

      setCarouselItems(nextItems);
      updateGallery();
    },
    [carouselItems, updateGallery]
  );

  return (
    <Container>
      <div className="gallery">
        <div className="gallery-container" ref={galleryContainer}>
            <Image
              className="gallery-item gallery-item-1"
              src={selectedItem === "estado_light" ? "/images/estado.png" : "/images/estado_light.png"}
              alt="Plano Estado"
              width={396}
              height={342}
              data-index="1"
              data-item={selectedItem === "estado_light" ? "estado" : "estado_light"}
              priority
            />
            <Image
              className="gallery-item gallery-item-2"
              src={selectedItem === 'institucional_light' ? "/images/institucional.png" : "/images/institucional_light.png"}
              alt="Plano Institucional"
              width={396}
              height={342}
              data-index="2"
              data-item={selectedItem === "institucional_light" ? "institucional" : "institucional_light"}
              priority
            />
            <Image
              className="gallery-item gallery-item-3"
              src={selectedItem === "gestao_light" ? "/images/gestao.png" : "/images/gestao_light.png"}
              alt="Plano Gestão"
              width={396}
              height={342}
              data-index="3"
              data-item={selectedItem === "gestao_light" ? "gestao" : "gestao_light"}
              priority
            />
            <Image
              className="gallery-item gallery-item-4"
              src={selectedItem === 'setorial_light' ? "/images/setorial.png" : "/images/setorial_light.png"}
              alt="Plano Setorial"
              width={396}
              height={342}
              data-index="4"
              data-item={selectedItem === "setorial_light" ? "setorial" : "setorial_light"}
              priority
            />
            <Image
              className="gallery-item gallery-item-5"
              src={selectedItem === "orcamentario_light" ? "/images/orcamentario.png" : "/images/orcamentario_light.png"}
              alt="Plano Orçamentário"
              width={396}
              height={342}
              data-index="5"
              data-item={selectedItem === "orcamentario_light" ? "orcamentario" : "orcamentario_light"}
              priority
            />
        </div>
      </div>
      <div className="gallery-controls" ref={galleryControlsContainer}>
        <div
          onClick={(e) => setCurrentState("previous")}
          className="gallery-controls-previous"
        />
        <div
          onClick={(e) => setCurrentState("next")}
          className="gallery-controls-next"
        />
      </div>
    </Container>
  );
};
